import ReactDOM from "react-dom/client";
import LanguageDetector from "i18next-browser-languagedetector";
import { CacheService } from "@microsoft/mgt-element";
import HttpApi from "i18next-http-backend";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { initializeFileTypeIcons } from "@fluentui/react-file-type-icons";
import App from "./App";
import "./index.css";
import translationEn from "./assets/locales/en/translation.json";
import translationFr from "./assets/locales/fr/translation.json";
import translationEs from "./assets/locales/es/translation.json";
import { authService } from "./services/AuthService";

function initializeCache() {
  CacheService.config.users.isEnabled = true;
  CacheService.config.people.isEnabled = true;
  CacheService.config.users.invalidationPeriod = 86400000;
  CacheService.config.people.invalidationPeriod = 86400000;
}

function initializeI18n() {
  const resources = {
    en: { translation: translationEn },
    fr: { translation: translationFr },
    es: { translation: translationEs },
  };
  
  i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(HttpApi)
    .init({
      fallbackLng: "en",
      resources,
      detection: {
        order: ["cookie", "htmlTag", "localStorage", "path", "subdomain"],
        caches: ["cookie"],
      },
      react: { useSuspense: false },
    });
}


function initializeApp() {
  initializeFileTypeIcons();
  initializeCache();
  initializeI18n();
  
  authService.initialize().then(() => { 
    // Render the app
    const root = ReactDOM.createRoot(
      document.getElementById("root") as HTMLElement
    );
    
    root.render(<App />);
  });
}

initializeApp();